import React from "react";
import "./src/styles/global.css";

import Global from "./src/Global";

export const wrapRootElement = ({ element }) => <Global>{element}</Global>;
